import React, { createContext } from 'react';
import { SavedQueryWidgetRenderContext } from '../types';
import { START_FROM_SAVED_QUERY_DROPDOWN } from '../widgetRenderContext.constants';

export const RenderModeContext = createContext<SavedQueryWidgetRenderContext>(
  START_FROM_SAVED_QUERY_DROPDOWN,
);

export const RenderModeProvider: React.FC<{
  mode: SavedQueryWidgetRenderContext;
}> = ({ mode, children }) => (
  <RenderModeContext.Provider value={mode}>
    {children}
  </RenderModeContext.Provider>
);
